import { DetailsWithPaymentForm } from "components/pages/details-with-payment-form";
import { SelectTime } from "components/pages/select-time";
import "config/i18n";
import BookingFlowLayout from "layout/booking-flow-layout";
import AvailabilityActivityBooking from "components/pages/availability-activity-booking";
import MyBooking from "components/pages/my-booking";
import MenuSelectView from "components/pages/menu-select-view";
import BookingPreorderView from "components/pages/booking-preorder-view";
import BookingWizard from "components/pages/booking-wizard";
import BookingRequestWizard from "components/pages/booking-request-wizard";
import { ErrorView } from "components/pages/error-view";
import ExperienceView from "components/pages/experience-view/experience-view";
import PaymentConfirmation from "components/pages/payment-confirmation";
import { matchPath, RouteObject } from "react-router-dom";
import { BookingProvider } from "store/store";
import Layout from "layout/layout";

const MY_BOOKING_ROUTES = {
    STANDARD: "/booking/:system/:bookingId",
    ACTIVITY: "/booking/:system/activity-booking/:bookingId",
} as const;

export const checkIsMyBookingPage = (pathname: string): boolean =>
    Object.values(MY_BOOKING_ROUTES).some((pattern) => matchPath(pattern, pathname));

export enum Routes {
    BOOKING = "booking",
    ACTIVITY_BOOKING = "activity-booking",
    BOOKING_REQUEST = "booking-request",
    WIZARD = "",
    AVAILABILITY = "availability",
    FINALIZE = "finalize",
    PAYMENT_CONFIRMATION = "payment-confirmation",
    PREORDER = "preorder",
    MENU_SELECT = "menu-select",
    EXPERIENCE_VIEW = "experience-view",
}

export const checkIsExperienceViewPage = (pathname: string): boolean =>
    pathname.includes(Routes.EXPERIENCE_VIEW);

export const checkIsDetailsForm = (pathname: string): boolean => pathname.includes(Routes.FINALIZE);

const routes: RouteObject[] = [
    {
        path: "/",
        errorElement: <ErrorView />,
        element: (
            <Layout>
                <BookingProvider />
            </Layout>
        ),
        children: [
            {
                path: MY_BOOKING_ROUTES.STANDARD,
                element: <MyBooking />,
            },
            {
                path: MY_BOOKING_ROUTES.ACTIVITY,
                element: <MyBooking />,
            },
            {
                path: `${MY_BOOKING_ROUTES.STANDARD}/${Routes.MENU_SELECT}`,
                element: <MenuSelectView />,
            },
            {
                path: `/:system/:unitId/${Routes.PAYMENT_CONFIRMATION}`,
                element: <PaymentConfirmation />,
            },
            {
                path: `/:system/:unitId/${Routes.PAYMENT_CONFIRMATION}/:bookingId`,
                element: <PaymentConfirmation />,
            },
            {
                path: `/:system/:unitId/${Routes.ACTIVITY_BOOKING}/${Routes.PAYMENT_CONFIRMATION}/:bookingId`,
                element: <PaymentConfirmation />,
            },
            {
                element: <BookingFlowLayout />,
                children: [
                    {
                        path: "/:system/:unitId",
                        children: [
                            { index: true, element: <BookingWizard /> },
                            {
                                path: Routes.AVAILABILITY,
                                element: <SelectTime />,
                            },
                            {
                                path: Routes.EXPERIENCE_VIEW,
                                children: [
                                    {
                                        index: true,
                                        element: <ExperienceView />,
                                    },
                                    {
                                        path: ":bookingId",
                                        element: <ExperienceView />,
                                    },
                                ],
                            },
                            {
                                path: Routes.PREORDER,
                                children: [
                                    {
                                        index: true,
                                        element: <BookingPreorderView />,
                                    },
                                    {
                                        path: ":bookingId",
                                        element: <BookingPreorderView />,
                                    },
                                ],
                            },
                            {
                                path: Routes.FINALIZE,
                                children: [
                                    { index: true, element: <DetailsWithPaymentForm /> },
                                    { path: ":bookingId", element: <DetailsWithPaymentForm /> },
                                ],
                            },
                        ],
                    },
                    {
                        path: `/:system/:unitId/${Routes.ACTIVITY_BOOKING}`,
                        children: [
                            { index: true, element: <BookingWizard /> },
                            {
                                path: Routes.AVAILABILITY,
                                element: <AvailabilityActivityBooking />,
                                children: [{ path: ":bookingId", element: null }],
                            },
                            { path: "finalize", element: <DetailsWithPaymentForm /> },
                            { path: "finalize/:bookingId", element: <DetailsWithPaymentForm /> },
                            { path: Routes.EXPERIENCE_VIEW, element: <ExperienceView /> },
                            {
                                path: `${Routes.EXPERIENCE_VIEW}/:bookingId`,
                                element: <ExperienceView />,
                            },
                        ],
                    },
                    {
                        path: `/:system/:unitId/${Routes.ACTIVITY_BOOKING}/${Routes.BOOKING_REQUEST}`,
                        children: [
                            { index: true, element: <BookingRequestWizard /> },
                            {
                                path: Routes.AVAILABILITY,
                                element: <AvailabilityActivityBooking />,
                                children: [{ path: ":bookingId", element: null }],
                            },
                            {
                                path: Routes.FINALIZE,
                                element: <DetailsWithPaymentForm />,
                                children: [{ path: ":bookingId", element: null }],
                            },
                        ],
                    },
                    {
                        path: `/:system/:unitId/${Routes.BOOKING_REQUEST}`,
                        children: [
                            { index: true, element: <BookingRequestWizard /> },
                            {
                                path: Routes.AVAILABILITY,
                                element: <SelectTime />,
                                children: [{ path: ":bookingId", element: null }],
                            },
                            {
                                path: Routes.FINALIZE,
                                element: <DetailsWithPaymentForm />,
                                children: [{ path: ":bookingId", element: null }],
                            },
                        ],
                    },
                ],
            },
        ],
    },
];

export default routes;
